import React from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import "@fontsource/chivo";

const Prenota = () => {
  return (
    <div className="bg-white min-h-screen text-black">
      <NavbarWhite />

      <div className="pt-32 px-6 text-center">
        <h1 className="text-4xl sm:text-5xl font-[chivo] text-[#009FB7] mb-10">
          Prenota Ora
        </h1>

        <div className="max-w-7xl mx-auto">
          <iframe
            src="https://widget.spiagge.it/stabilimenti-balneari/prenotazione/it-na-80069-lido-da-vittorio/"
            title="Prenotazione Lido Da Vittorio"
            style={{ width: "100%", height: "750px", border: "0" }}
            loading="lazy"
            className="rounded-xl shadow-lg"
          ></iframe>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Prenota;
